import { PageLayout } from '@app/pages/layout/PageLayout'
import { useQuery } from '@based/sdk/react'
import { useMemo } from 'react'
import { useLocation, useSearch } from 'wouter'
import { KnowledgeHubModule } from '@schema/knowledgeHubModule'
import { LeftSidebar } from '@app/components/layout/LeftSidebar'
import { KnowledgeHubModuleSidebar } from './KnowledgeHubModuleSidebar'
import { KnowledgeHubModuleContent } from './KnowledgeHubModuleContent'
import { useTranslations } from '@i18n/useLanguage'
import { pages } from '@app/util/links'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons'
import { styled } from 'inlines'
import { Text } from '@app/components/core/typography/Text'
import {
  linkStyle,
  linkSizeStyle,
  linkIconSizeStyle,
} from '@app/components/core/link/linkStyleHeper'

const BackLink = styled.a

export type KnowledgeHubItemPageProps = {
  itemId: string
}

export const KnowledgeHubModulePage = ({
  itemId,
}: KnowledgeHubItemPageProps) => {
  const t = useTranslations().app.knowledgeHubPage
  const [, setLocation] = useLocation()
  const knowledgeHubModuleQuery = useQuery('view-knowledge-hub-module', {
    id: itemId,
  })
  const knowledgeHubModuleItem: KnowledgeHubModule | undefined =
    knowledgeHubModuleQuery.data
  const search = useSearch()
  const itemSlug = useMemo(
    () =>
      new URLSearchParams(search).get('slug') ||
      knowledgeHubModuleItem?.sections?.[0]?.knowledgeHubItems?.[0]?.slug,
    [search, knowledgeHubModuleItem],
  )

  const handleBackClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    if (window.history.length > 1) {
      window.history.back()
    } else {
      setLocation(pages.knowledgeHub)
    }
  }

  if (knowledgeHubModuleQuery.loading || !knowledgeHubModuleItem) {
    return <PageLayout gap="2rem">{t.loading}</PageLayout>
  }

  return (
    <>
      <PageLayout gap="0rem">
        <LeftSidebar>
          <LeftSidebar.Sidebar collapsedButtonLabel={t.menu}>
            <KnowledgeHubModuleSidebar
              sections={knowledgeHubModuleItem.sections}
              activeSlug={itemSlug}
            />
          </LeftSidebar.Sidebar>
          <div>
            <BackLink
              href={pages.knowledgeHub}
              onClick={handleBackClick}
              style={linkStyle}
            >
              <FontAwesomeIcon
                icon={faArrowLeft}
                style={linkIconSizeStyle.medium}
              />
              <Text.Medium style={linkSizeStyle.medium}>{t.back}</Text.Medium>
            </BackLink>
            <KnowledgeHubModuleContent id={itemSlug || ''} />
          </div>
        </LeftSidebar>
      </PageLayout>
    </>
  )
}
